export class AccItemFinalizeStatusParameterDto {
    finalized: boolean;
    communityId: number;
    customerId: string;
    accItemId: number;
    clearCache: boolean;
}
